var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.61133H6C3.23858 1.61133 1 3.81887 1 6.542V16.4034C1 19.1265 3.23858 21.334 6 21.334H16C18.7614 21.334 21 19.1265 21 16.4034V6.542C21 3.81887 18.7614 1.61133 16 1.61133Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 10.8513C15.1231 11.672 14.981 12.5102 14.5935 13.2466C14.206 13.9831 13.5929 14.5803 12.8413 14.9533C12.0898 15.3263 11.2382 15.4562 10.4075 15.3243C9.57683 15.1925 8.80947 14.8058 8.21455 14.2191C7.61962 13.6324 7.22744 12.8757 7.09377 12.0566C6.96011 11.2374 7.09177 10.3976 7.47003 9.65647C7.84829 8.91537 8.45389 8.31076 9.20069 7.92863C9.94749 7.5465 10.7975 7.40632 11.6297 7.52802C12.4786 7.65216 13.2646 8.04226 13.8714 8.64068C14.4782 9.23911 14.8738 10.0141 14.9997 10.8513Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.04883H16.51",
    stroke: "#D3D3D3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.86089e1a8e1dd35fa0a1125b318e1b16.svg";
export { ForwardRef as ReactComponent };